import React, { useState, useEffect } from 'react';
import { getVendorStats } from '../../api/vendorApi';

const VendorStats = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await getVendorStats();
        setStats(response.data.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch vendor statistics.');
        setLoading(false);
      }
    };
    fetchStats();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-20">
        <span className="animate-spin h-8 w-8 border-4 rounded-full border-orange-500 border-t-transparent"></span>
      </div>
    );
  }

  if (error) {
    return <div className="text-red-500 text-center">{error}</div>;
  }

  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
      <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-blue-500">
        <h3 className="text-lg font-semibold text-gray-500">Total Vendors</h3>
        <p className="text-4xl font-bold text-gray-900 mt-2">{stats.total}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-green-500">
        <h3 className="text-lg font-semibold text-gray-500">Active Vendors</h3>
        <p className="text-4xl font-bold text-gray-900 mt-2">{stats.active}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-yellow-500">
        <h3 className="text-lg font-semibold text-gray-500">Pending Approval</h3>
        <p className="text-4xl font-bold text-gray-900 mt-2">{stats.pending}</p>
      </div>
      <div className="bg-white p-6 rounded-lg shadow-md border-t-4 border-purple-500">
        <h3 className="text-lg font-semibold text-gray-500">Recently Added</h3>
        <p className="text-4xl font-bold text-gray-900 mt-2">{stats.recent}</p>
      </div>
    </div>
  );
};

export default VendorStats;